import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';
import { isNewTabKey, openNewTab } from '@/ui/helpers';
import { router } from '@/ui/routes';

export const startNewInspection = (checklistId: number, event: MouseEvent|undefined) => {
  trackClick(CLICK_EVENTS.CREATE_INSPECTION);
  if (event && isNewTabKey(event)) {
    openNewTab(makeNewInspectionHref(checklistId));
    return;
  }

  router.push(makeNewInspectionRouteObject(checklistId));
};

export const makeNewInspectionHref = (checklistId: number): string => {
  const { href } = router.resolve(makeNewInspectionRouteObject(checklistId));

  return href;
};

const makeNewInspectionRouteObject = (checklistId: number) => ({
  name: 'inspectionCreate',
  params: { id: checklistId.toString() },
});
